"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const react_1 = __importDefault(require("react"));
const react_icons_1 = require("@grandlinex/react-icons");
const TabBar_1 = __importDefault(require("./TabBar"));
const util_1 = require("../../../util");
const Header = function (props) {
    const { prop, tabs } = props;
    const { electron, refresh, icon } = prop;
    return (react_1.default.createElement("div", { className: (0, util_1.cnx)('tab-header', [!electron, 'head-web', 'head-native']) },
        react_1.default.createElement("div", { className: "title" }, icon || react_1.default.createElement(react_icons_1.IOPodium, null)),
        react_1.default.createElement(TabBar_1.default, { c: tabs }),
        electron ? (react_1.default.createElement("div", { className: "keys" },
            react_1.default.createElement("button", { type: "button", onClick: () => {
                    electron.minimize();
                } },
                react_1.default.createElement(react_icons_1.IXMinimize, { height: react_icons_1.ISize.SM, width: react_icons_1.ISize.SM })),
            react_1.default.createElement("button", { type: "button", onClick: () => {
                    electron.maximize();
                } },
                react_1.default.createElement(react_icons_1.IOBrowsersOutline, { size: react_icons_1.ISize.SM })),
            react_1.default.createElement("button", { className: "cancel", type: "button", onClick: () => {
                    electron.close();
                } },
                react_1.default.createElement(react_icons_1.IOClose, { size: react_icons_1.ISize.SM })))) : null,
        refresh ? (react_1.default.createElement("div", { className: "refresh" },
            react_1.default.createElement("button", { type: "button", onClick: () => {
                    refresh();
                } },
                react_1.default.createElement(react_icons_1.IOReloadOutline, { size: react_icons_1.ISize.SM })))) : null));
};
exports.Header = Header;
